import { render } from "./ProcessLoader.vue?vue&type=template&id=ad701a00&scoped=true"
import script from "./ProcessLoader.vue?vue&type=script&lang=js"
export * from "./ProcessLoader.vue?vue&type=script&lang=js"

import "./ProcessLoader.vue?vue&type=style&index=0&id=ad701a00&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/wz-case-form-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad701a00"]])

export default __exports__